import { useMemo } from 'react';
import Appointment from '../QrTypes/Appointment';
import Asset from '../QrTypes/Asset';
import Location from '../QrTypes/Location';
import RedirectLink from '../QrTypes/RedirectLink';
import GoogleReview from '../QrTypes/GoogleReview';
import Microsite from '../QrTypes/Microsite';
import PDF from '../QrTypes/PDF';
import Tracker from '../QrTypes/Tracker';
import Survey from '../QrTypes/Survey';
import BitSignal from '../QrTypes/BitSignal';
import Nickname from '../Nickname';
import QrConnect from '../QrTypes/QrConnect';
import styles from './Options.module.css';
import Description from '../Description';

export default function Options(props) {

    const { qr_type, reference } = props;

    const returnType = useMemo(() => {
        switch (qr_type) {
            case 'appointment':
                return <Appointment reference={reference} />;
            case 'assets':
            case 'container-label':
            case 'inventory':
                return <Asset reference={reference} />;
            case 'location':
                return <Location reference={reference} />;
            case 'link':
            case 'youtube':
            case 'tiktok':
            case 'linkedin':
            case 'review-link':
            case 'menu-link':
                return <RedirectLink reference={reference} />;
            case 'google-review':
                return <GoogleReview reference={reference} />;
            case 'microsite':
            case 'landing-page':
                return <Microsite reference={reference} />;
            case 'menu-pdf':
            case 'pdf':
            case 'brochure':
            case 'user-manual':
                return <PDF reference={reference} />;
            case 'tracker':
            case 'workout-log':
            case 'service-log':
            case 'vehicle-log':
            case 'maintenance-tracker':
            case 'liquid-label':
            case 'liquid-poster':
            case 'for-sale':
            case 'garden-label':
                return <Tracker reference={reference} />;
            case 'survey':
            case 'review':
            case 'contact-form':
            // case 'bug-report':
                return <Survey reference={reference} />;
            case 'bitsignal':
            case 'dbc':
                return <BitSignal reference={reference} />
            case 'connect':
                return <QrConnect reference={reference} />
            default:
                // what should default be?
                return <></>;
        };
    },[qr_type]);

    return (
        <div className={styles.container}>
            <div className={styles.header}>Configure</div>
            <Nickname reference={reference} />
            <Description reference={reference} qr_type={qr_type} />
            {returnType}
        </div>
    )
};
